import { ActionReducerMap } from '@ngrx/store';
import {
  ShowcasesState,
  showcasesReducer,
} from './showcases.reducer';

export interface FullCardState {
  showcases: ShowcasesState;
}

export const fullCardReducers: ActionReducerMap<FullCardState> = {
  showcases: showcasesReducer,
};
